import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import {
	IEditFormForClientManagerContext,
	EditFormForClientManagerContext,
} from '../../../EditFormForClientManagerState/editFormForClientManagerContext';
import { useCompareFormData } from 'hooks/useCompareFormData';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		useMenuVersion,
		useContentVersion,
		restaurantMenuVersion,
		restaurantContentVersion,
		initialFormData,
	} = useContext<IEditFormForClientManagerContext>(EditFormForClientManagerContext);

	const containerClasses = classNames(style.container, {
		[style.visible]: useMenuVersion || useContentVersion || restaurantMenuVersion || restaurantContentVersion,
	});

	const currentFormData = {
		useMenuVersion,
		useContentVersion,
		restaurantMenuVersion,
		restaurantContentVersion,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses}>
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" disabled={isEqualFormData} type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
